<template>
  <div>
    <div class="row">
      <div class="col">
        <h1>Order Payment</h1>

        <div class="text-center py-5" v-if="isLoading">
          <b-spinner
            style="width: 3rem; height: 3rem"
            label="Large Spinner"
          ></b-spinner>
        </div>

        <b-alert variant="danger" :show="hasError && !isLoading">{{
          errorMessage
        }}</b-alert>

        <div class="row mt-5" v-if="!isLoading && order && order.financial_status=='pending'">
          <div class="col-md-6">
            <h6 class="pt-3 pr-lg-3">
              To make a payment of <strong>R{{order.total_price}}</strong> for the displayed order, click on the button below to be redirect to
              the FNB Card Payments Page.
            </h6>
            <a @click="fnbPrepare" class="btn btn-success my-3 text-white font-weight-bold">PAY NOW</a>
          </div>
          <div class="col-md-6">
            <div v-if="order">
              <div class="card border">
                <div class="card-body">
                  <div class="row py-1">
                    <div class="col-4"><strong>Order</strong></div>
                    <div class="col-8 text-right">{{ order.order_number }}</div>
                  </div>

                  <div class="row">
                    <div class="col-12 py-3">
                      <div class="border-bottom"></div>
                    </div>
                  </div>

                  <div
                    class="row py-1 font-size-13 font-weight-600"
                    v-for="line in order.line_items"
                    :key="line.id"
                  >
                    <div class="col-5">{{ line.name }}</div>
                    <div class="col-4 text-right">
                      {{ line.price }} x {{ line.quantity }}
                    </div>
                    <div class="col-3 text-right">
                      R {{ (line.price * line.quantity).toFixed(2) }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 py-3">
                      <div class="border-top"></div>
                    </div>
                  </div>
                  <div class="row py-1">
                    <div class="col-4">Sub Total</div>
                    <div class="col-8 text-right">
                      {{ order.subtotal_price }}
                    </div>
                  </div>
                   <div class="row py-1" v-if="order.shipping > 0">
                    <div class="col-4">Shipping</div>
                    <div class="col-8 text-right">
                      {{ order.shipping }}
                    </div>
                  </div>
                  <div class="row py-1">
                    <div class="col-4">Vat</div>
                    <div class="col-8 text-right">{{ order.total_tax }}</div>
                  </div>
                  <div class="row py-1">
                    <div class="col-4">
                      <h6 class="font-weight-bold">Total</h6>
                    </div>
                    <div class="col-8 text-right">
                      <h6 class="font-weight-bold">
                        R {{ order.total_price }}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       
      </div>
    </div>
  </div>
</template>

<script>
import frontendRepo from "@/api/repos/frontendRepo";

export default {
  mounted() {
    this.fetchOrder();
  },

  data() {
    return {
      hasError: false,
      errorMessage: "",
      isLoading: true,
      order: null,
    };
  },

  methods: {
    async fetchOrder() {
      this.isLoading = true;
      try {
        let { data } = await frontendRepo.getOrder(this.$route.params.id);
        this.order = data.order;
      } catch (e) {
        this.hasError = true;
        if (e.response.status == 400) {
          this.errorMessage = "Order can not be paid for: "+e.response.data.message;
          return false;
        }

        this.errorMessage = "Something went wrong.";
      } finally {
        this.isLoading = false;
      }
    },
    async fnbPrepare() {
      this.isLoading = true;
      try {
        // alert("coming soon, this will redirect ot fnb payment portal page")
        // return false
        let { data } = await frontendRepo.fnbPrepare(this.order.internal_id);
        window.location.assign(data.url)
      } catch ($e) {
        this.hasError = true;       
        this.errorMessage = "Something went wrong.";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
</style>